import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

import { StylesProvider, MuiThemeProvider } from "@material-ui/core/styles";
import { theme } from "loft-taxi-mui-theme";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import createAppStore from "./store";

ReactDOM.render(
  <React.StrictMode>
    <StylesProvider injectFirst>
      <MuiThemeProvider theme={theme}>
        <Provider store={createAppStore()}>
          <BrowserRouter>
              <App />
          </BrowserRouter>
        </Provider>
      </MuiThemeProvider>
    </StylesProvider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
